import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './styles';
import { PUBLIC_URL } from '../../../config';
import { useSweep } from '../../../hooks/useSweep';
import { getSportTypeConfig } from '../../../sports/configs';

export const SkyBetOddsLink = ({ href }) => {
    const { sweep } = useSweep();
    const sportConfig = getSportTypeConfig(sweep.sportType);

    return (
        <Styled.Wrapper href={href}>
            Check out your {sportConfig.labels.selectionNounPossessive} latest
            odds on
            <Styled.SkyBetLogo
                src={`${PUBLIC_URL}/img/logos/skybet-secondary.png`}
            />
            <Styled.RightCaret src={`${PUBLIC_URL}/img/right-caret.png`} />
        </Styled.Wrapper>
    );
};

SkyBetOddsLink.propTypes = {
    href: PropTypes.string.isRequired
};

export default SkyBetOddsLink;
